import { createRouter, createWebHistory } from 'vue-router'
import store from './store'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'
import { getRealmFromSubDomain } from './services/oidc.service'
import * as Sentry from '@sentry/vue'
const oidcRouterMiddleWare = vuexOidcCreateRouterMiddleware(store)
const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/oauth2', // Needs to match redirectUri (redirect_uri if you use snake case) in your oidcSettings
      name: 'oidcCallback',
      component: () => import('@/pages/authentication/Redirect.vue')
    },
    {
      path: '/silentrenew', // Needs to match silentRedirectUri in your oidcSettings
      name: 'silentrenew',
      component: () => import('@/pages/authentication/SilentRenew.vue')
    },
    {
      path: '/info',
      name: 'info',
      component: () => import('@/pages/SplashScreen.vue')
    },
    {
      path: '/realm',
      name: 'realm',
      component: () => import('@/pages/RealmPage.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/home/:pathMatch(.*)*',
      name: 'home',
      component: () => import('@/pages/HomePage.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/',
      name: 'landingpage',
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      redirect: (to) => {
        const internalZynkaUser = localStorage.getItem('internalZynkaUser') === 'true'
        const atInternalDomain = !getRealmFromSubDomain()

        if (internalZynkaUser || !atInternalDomain) {
          return { name: 'home' }
        }
        return { name: 'info' }
      }
    },
    // Below, Instance refers to Ivion site, which was previously called IndoorViewer instance in this project
    // IndoorViewer was NavVis' old product name and, at that time, an instance was somewhat similar to an Ivion site
    {
      path: '/instance/:pathMatch(.*)*',
      name: 'instance',
      component: () => import('@/pages/Instance.vue'),
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'pageNotFound',
      component: () => import('@/pages/PageNotFound.vue')
    }
  ]
})

// First middleware: Check authentication
router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    oidcRouterMiddleWare(to, from, next)
  } else {
    next()
  }
})

// Second middleware: Set user info in Sentry
router.beforeEach((to, from, next) => {
  const state: any = store.state
  const user = state?.oidcStore?.user
  if (user) {
    Sentry.getCurrentScope()?.setUser({
      id: user.sid
    })
    Sentry.getCurrentScope()?.setTags({
      route: to.path,
      audience: user.aud,
      'user-type': user.userType,
      realm: getRealmFromSubDomain()
    })
  }
  next()
})

export default router
